var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAccelerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 80,
    viewBox: "0 0 72 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shapeicon-accelerate",
    d: "M12.207,29.594,8.325,37,0,37l3.882-7.406Zm16.609,0V37l-8.343,0v-7.4Zm0-14.77V22.23H7.719L11.6,14.824ZM21.41,0A7.406,7.406,0,0,1,28.8,6.9l.017.507H15.405L19.287,0Z",
    transform: "translate(19.592 21.5)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAccelerate);
export default __webpack_public_path__ + "static/media/logo-accelerate.5a2159003968ae17f875705755e9352c.svg";
export { ForwardRef as ReactComponent };